export const getSimProductIdFromUrl = () => {
	if (
		typeof window !== "undefined" &&
		window.location.search.includes("simProductId=")
	) {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const simProductId = urlParams.get("simProductId");
		return simProductId ? Number(simProductId) : null;
	}

	return null;
};
